import { __decorate } from "tslib";
import { Group, Matrix4, Vector3 } from "three";
import { Config } from "../../Config/Config.js";
import { CachedMeasure } from "../../Core/CachedMeasure.js";
import { Save, SaveChild } from "../../Core/Save.js";
import { bindedModelBase } from "../../Models/BindedModel.js";
import { LimitUtils } from "../../Utils/LimitUtils.js";
import { VectorUtils } from "../../Utils/VectorUtils.js";
import { DraggablePoint } from "../Primitive/DraggablePoint.js";
import { LabelAngle } from "../Primitive/Label/LabelAngle.js";
import { LimitLine } from "../Primitive/LimitLine.js";
import { LinePointToPoint2 } from "../Primitive/LinePointToPoint2.js";
import { AnatomicalAxisType } from "./AnatomicalAxis.js";
// TODO: Ac e Bc non devono allinearsi 
export class AnatomicalAxis2 extends Group {
    get oppositePoint() {
        return this.Ac.position;
    }
    get oppositeToAc() {
        return this.A;
    }
    get axisApexA() {
        return this.oppositeToAc.position;
    }
    get axisApexB() {
        return this.Ac.position;
    }
    constructor(viewType, type, startPosition) {
        super();
        this.distance_A_B = 80;
        this.distance_A_Ac = 10;
        this.distance_A1_A2 = 30;
        this._limitLines = [];
        this._enableLimits = false; // refresh page to make it works (to improve performance when don't use it)
        this.name = 'AnatomicalAxis2';
        if (this._enableLimits) {
            this._limitLines[0] = new LimitLine(viewType, 0xffff00);
            this._limitLines[1] = new LimitLine(viewType, 0x00ffff);
        }
        const prefix = type === AnatomicalAxisType.reference ? 'ref_' : 'mov_';
        this.add(this.A = new DraggablePoint('A', viewType, Config[`${prefix}A`]), this.Ac = new DraggablePoint('Ac', viewType, Config[`${prefix}Ac`]), this.A1 = new DraggablePoint('A1', viewType, Config[`${prefix}A1`]), this.A2 = new DraggablePoint('A2', viewType, Config[`${prefix}A2`]), this.center = new DraggablePoint('center', viewType, Config[`${prefix}center`]), this.A_Ac_Line = new LinePointToPoint2('A_B_Line', viewType, Config[`${prefix}A_B_Line`], this.A, this.Ac), this.A1_A2_Line = new LinePointToPoint2('A1_A2_Line', viewType, Config[`${prefix}A1_A2_Line`], this.A1, this.A2), this.A1AAngleLabel = new LabelAngle({
            name: 'AcA1Label',
            arcA: this.A1,
            arcB: this.A,
            arcCenter: this.Ac,
            viewType: viewType,
            labelAnchor: new Vector3(10) /*new Vector3(isLeft ? -7 : 7, 5)*/,
            labelParams: { backgroundColor: "rgba(236, 68, 204, 0.6)" /*Config.BCO2AngleLabel_backgroundColor*/, fontColor: "#ffffff" /*Config.BCO2AngleLabel_fontColor*/ },
        }), ...this._limitLines);
        this.A1A = new CachedMeasure(() => {
            return this.A.position.clone().sub(this.Ac.position).angleTo(this.A1.position.clone().sub(this.Ac.position));
        }, this.A, this.Ac);
        this.bindEvents();
        this.initPosition(type, startPosition);
        this.update();
    }
    initPosition(type, startPosition) {
        const distance_A_B = type === AnatomicalAxisType.reference ? -this.distance_A_B : this.distance_A_B;
        const distance_A_Ac = type === AnatomicalAxisType.reference ? -this.distance_A_Ac : this.distance_A_Ac;
        this.A.position.set(0, distance_A_B / 2, 0).add(startPosition);
        this.Ac.position.set(0, distance_A_B / -2 - distance_A_Ac, 0).add(startPosition);
        this.A1.position.setX(this.distance_A1_A2 / -2).add(this.Ac.position);
        this.A2.position.setX(this.distance_A1_A2 / 2).add(this.Ac.position);
        this.center.position.copy(startPosition);
        this.AB_dirOrigin = this.A.position.clone().sub(this.Ac.position);
        this.AB_dirOrigin_perp = VectorUtils.getPerpendicular(this.AB_dirOrigin);
    }
    update() {
        //const PDFAValid = Utils.isRadiantsAngleInRangeDegrees(this.PDFA.value, Consts.paleyAngles.LT.PDFA.min, Consts.paleyAngles.LT.PDFA.max);
        //this.BCO2AngleLabel.setParams(
        //  { key: 'text', value: FormatUtils.angleRadiantsWithNameAndSymbol('BCO2', this.BCO2.value) },
        //  //{ key: 'backgroundColor', value: PDFAValid ? Config.PDFALabel_backgroundColor : 'rgba(255, 0, 0, 0.6)' },
        //  //{ key: 'fontColor', value: PDFAValid ? Config.PDFALabel_fontColor : '#ffffff' },
        //);
        // this.A1AAngleLabel.setParam("text", FormatUtilsBase.angleRadiantsWithNameAndSymbol('A1A', this.A1A.value));
    }
    bindEvents() {
        this.bindEvent('onAfterDragMove', (args) => {
            this.update();
        });
        this.center.bindEvent('onDragMove', (args) => {
            if (bindedModelBase.syncAnatomicalAxis)
                return;
            args.preventDefault = true;
            // does not allow to Bc to switch with opposite Bc
            const newAc = this.Ac.position.clone().add(args.position.clone().sub(this.center.position));
            const diff = newAc.clone().sub(this.oppositePointLimit).projectOnVector(this.AB_dirOrigin);
            if (VectorUtils.haveSameDirection(this.AB_dirOrigin, diff)) {
                args.position.sub(diff);
            }
            const translation = args.position.clone().sub(this.center.position);
            this.translateAllPoints(translation);
        });
        this.A1.bindEvent('onDragMove', (args) => {
            if (bindedModelBase.syncAnatomicalAxis)
                return;
            LimitUtils.applyLimitAndProjectVector(this.A.position, this.A2.position, args.position, this.A1.position, 0.1, this._limitLines[0]);
            // does not allow to Ac to swith with Bc (does not allow to A B line to exceed 90 degrees)
            const newAc = this.A2.position.clone().lerp(args.position, 0.5);
            this.preventReverse(args.position, newAc, this.A.position, this.Ac.position.clone().sub(this.AB_dirOrigin));
            this.Ac.position.lerpVectors(args.position, this.A2.position, 0.5);
            this.center.position.lerpVectors(this.Ac.position, this.A.position, 0.5);
        });
        this.A2.bindEvent('onDragMove', (args) => {
            if (bindedModelBase.syncAnatomicalAxis)
                return;
            LimitUtils.applyLimitAndProjectVector(this.A.position, this.A1.position, args.position, this.A2.position, 0.1, this._limitLines[0]);
            // does not allow to Ac to swith with Bc (does not allow to A B line to exceed 90 degrees)
            const newAc = this.A1.position.clone().lerp(args.position, 0.5);
            this.preventReverse(args.position, newAc, this.A.position, this.Ac.position.clone().sub(this.AB_dirOrigin));
            this.Ac.position.lerpVectors(args.position, this.A1.position, 0.5);
            this.center.position.lerpVectors(this.Ac.position, this.A.position, 0.5);
        });
        this.Ac.bindEvent('onDragMove', (args) => {
            if (bindedModelBase.syncAnatomicalAxis)
                return;
            args.position.copy(VectorUtils.projectOnVector(args.position, this.Ac.position, this.A.position));
            // does not allow to Bc to switch with opposite Bc
            const diff = args.position.clone().sub(this.oppositePointLimit).projectOnVector(this.AB_dirOrigin);
            if (VectorUtils.haveSameDirection(this.AB_dirOrigin, diff)) {
                args.position.copy(VectorUtils.lines2DIntersection(this.A.position, this.Ac.position, this.oppositePointLimit, this.oppositePointLimit.clone().add(this.AB_dirOrigin_perp)));
            }
            LimitUtils.applyLimitAndProjectVector(this.A.position, this.A.position.clone().add(this.A1.position.clone().sub(this.A2.position)), args.position, this.Ac.position, 0.1, this._limitLines[0]);
            const transl = args.position.clone().sub(this.Ac.position);
            this.A1.position.add(transl);
            this.A2.position.add(transl);
            this.center.position.lerpVectors(args.position, this.A.position, 0.5);
        });
        this.A.bindEvent('onDragMove', (args) => {
            if (bindedModelBase.syncAnatomicalAxis)
                return;
            LimitUtils.applyLimitAndProjectVector(this.A1.position, this.A2.position, args.position, this.A.position, 0.1, this._limitLines[0]);
            LimitUtils.applyLimitAndProjectVector(this.Ac.position, this.Ac.position.clone().add(this.AB_dirOrigin_perp), args.position, this.A.position, 0.1, this._limitLines[1]);
            this.center.position.lerpVectors(this.Ac.position, args.position, 0.5);
        });
    }
    preventReverse(position, newC1, C2, validPoint) {
        const limitedC1 = LimitUtils.applyLimitAndProjectVector(C2, C2.clone().add(this.AB_dirOrigin_perp), newC1.clone(), validPoint);
        position.add(limitedC1.sub(newC1).multiplyScalar(2));
    }
    translateAllPoints(translation) {
        this.A.position.add(translation);
        this.Ac.position.add(translation);
        this.A1.position.add(translation);
        this.A2.position.add(translation);
        this.center.position.add(translation);
    }
    rotateAllPoints(angle, rotationCenter) {
        const matrix = new Matrix4();
        matrix.makeRotationZ(angle);
        this.A1.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
        this.A2.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
        this.Ac.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
        this.center.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
        this.A.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
    }
}
__decorate([
    Save("position")
], AnatomicalAxis2.prototype, "A", void 0);
__decorate([
    Save("position")
], AnatomicalAxis2.prototype, "A1", void 0);
__decorate([
    Save("position")
], AnatomicalAxis2.prototype, "A2", void 0);
__decorate([
    Save("position")
], AnatomicalAxis2.prototype, "Ac", void 0);
__decorate([
    Save("position")
], AnatomicalAxis2.prototype, "center", void 0);
__decorate([
    SaveChild()
], AnatomicalAxis2.prototype, "A1AAngleLabel", void 0);
//# sourceMappingURL=AnatomicalAxis2.js.map